module.exports = __webpack_public_path__ + "img/jiaot4.51a70bc3.png";